import { ArrowRight, Phone } from "lucide-react";
import { useSilver, scrollToId } from "@/context/SilverContext";
import { CONTACT } from "@/data/content";
import { fmtInt } from "@/components/silver/common/AnimatedNumber";
import { Reveal } from "@/components/silver/common/Reveal";

export default function FinalCTA() {
  const { phase, audience } = useSilver();
  const hasResult = phase === "results" && audience.total > 0;
  return (
    <section id="talk" className="relative mx-auto max-w-7xl px-5 pb-28 sm:px-8" data-testid="final-cta-section">
      <Reveal className="glass relative overflow-hidden px-8 py-16 sm:px-14 sm:py-20">
        <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(150,193,31,0.3),transparent_60%)]" aria-hidden="true" />
        <div className="relative max-w-3xl">
          <p className="eyebrow">Start the conversation</p>
          <h2 className="mt-6 text-4xl font-extrabold leading-[1.02] tracking-[-0.045em] sm:text-5xl lg:text-6xl">
            {hasResult ? <>{fmtInt(audience.total)} households.<br /><span className="text-[#C6EE5A]">One campaign.</span></> : <>Your patch.<br /><span className="text-[#C6EE5A]">Your homeowner audience.</span></>}
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/65 sm:text-[17px]">Reach the homeowners others are missing — then let NicheCom Print take it from postcode to doormat.</p>
          <div className="mt-10 flex flex-wrap gap-3">
            <button type="button" className="btn-primary" onClick={() => scrollToId(hasResult ? "campaign-builder" : "build")} data-testid="final-cta-build-btn">
              {hasResult ? "Build the campaign" : "Build an audience"} <ArrowRight className="h-4 w-4" />
            </button>
            <a href={CONTACT.phoneHref} className="btn-ghost" data-testid="final-cta-call-link"><Phone className="h-4 w-4 text-[#C6EE5A]" /> Talk to Print · {CONTACT.phone}</a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
